import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './dashboard.css'; 
import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
import Cookies from 'js-cookie';
import { decryptData } from "../../Auth/cryptage";
import { Bar } from 'react-chartjs-2'; 
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip } from 'chart.js';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FaUsers } from "react-icons/fa6";
import { MdOutlineGeneratingTokens } from "react-icons/md";
import { FaDatabase } from "react-icons/fa6";
import { ring } from 'ldrs';

function Dashboard() {
    ChartJS.register(
        BarElement,
        CategoryScale,
        LinearScale,
        Title,
        Tooltip
    );
    ring.register();

    const MySwal = withReactContent(Swal);
    const user = JSON.parse(decryptData(Cookies.get('user')));
    const [names, setNames] = useState([]);
    const [nbrInputChars, setNbrInputChars] = useState([]);
    const [nbrOutChars, setNbrOutChars] = useState([]);
    const [database, setDatabase] = useState({});
    const [loading, setLoading] = useState(false);
    const [usersCount, setUsersCount] = useState(0);
    const [totalInputToken, setTotalInputToken] = useState(0);
    const [totalOutToken, setTotalOutToken] = useState(0);

    useEffect(() => {
        getToken();
    }, []);

    useEffect(() => {
        setUsersCount(names.length);
        setTotalInputToken(nbrInputChars.reduce((total, current) => total + current, 0));
        setTotalOutToken(nbrOutChars.reduce((total, current) => total + current, 0));
    }, [names, nbrInputChars,nbrOutChars]);

    useEffect(() => {
        document.title = "GecimmoIA - Dashboard";
    }, []);

    const getToken = async () => {
        setLoading(true);
        try {
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get('https://api.ai.easysystem.cloud/api/admin/TotalTokens', {
                headers: {
                    'X-Custom-Token': token
                },
            });
            setNames(result.data.names || []);
            setNbrInputChars(result.data.NbrInputChars || []);
            setNbrOutChars(result.data.NbrOutChars);
            setDatabase(result.data.databaseConfig || {});
            // console.log(result.data.databaseConfig);
        } catch (error) {
            console.error("Error fetching users: ", error);
            MySwal.fire({
                title: "Erreur !",
                text: "Une erreur est survenue lors de la récupération des utilisateurs.",
                icon: "error"
            });
        } finally {
            setLoading(false);
        }
    };

    const colors = [
        'rgba(255, 99, 132, 0.6)', 'rgba(54, 162, 235, 0.6)', 'rgba(255, 206, 86, 0.6)',
        'rgba(75, 192, 192, 0.6)', 'rgba(153, 102, 255, 0.6)', 'rgba(255, 159, 64, 0.6)',
        'rgba(199, 199, 199, 0.6)', 'rgba(83, 102, 255, 0.6)', 'rgba(255, 99, 71, 0.6)',
        'rgba(50, 205, 50, 0.6)', 'rgba(106, 90, 205, 0.6)', 'rgba(255, 140, 0, 0.6)',
        'rgba(70, 130, 180, 0.6)', 'rgba(244, 164, 96, 0.6)', 'rgba(127, 255, 0, 0.6)',
        'rgba(0, 128, 128, 0.6)', 'rgba(255, 215, 0, 0.6)', 'rgba(147, 112, 219, 0.6)',
        'rgba(210, 105, 30, 0.6)', 'rgba(95, 158, 160, 0.6)', 'rgba(255, 20, 147, 0.6)',
        'rgba(0, 191, 255, 0.6)', 'rgba(34, 139, 34, 0.6)', 'rgba(123, 104, 238, 0.6)',
        'rgba(233, 150, 122, 0.6)', 'rgba(218, 165, 32, 0.6)', 'rgba(144, 238, 144, 0.6)',
        'rgba(72, 209, 204, 0.6)', 'rgba(255, 182, 193, 0.6)', 'rgba(60, 179, 113, 0.6)'
    ];

    const chartData = {
        labels: names, 
        datasets: [
            {
                label: 'Input Characters',
                data: nbrInputChars, 
                backgroundColor: colors,
                borderColor: 'rgba(255, 99, 132, 0.6)',
                borderWidth: 2,
                yAxisID: 'y1', 
            },
            {
                label: 'Output Characters',
                data: nbrOutChars, 
                backgroundColor: colors,
                borderColor: 'rgba(244, 164, 96, 0.6)', 
                borderWidth: 2,
                yAxisID: 'y2', 
            },
        ],
    };
    
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        scales: {
            y1: {
                type: 'linear',
                position: 'left',
                title: {
                    display: true,
                    text: 'Input Characters',
                },
            },
            y2: {
                type: 'linear',
                position: 'right',
                title: {
                    display: true,
                    text: 'Output Characters',
                },
                grid: {
                    drawOnChartArea: false, 
                },
            },
        },
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.dataset.label}: ${context.raw}`,
                },
            },
        },
    };

    return (
        <Container className="d-flex flex-column align-items-center justify-content-center p-4">
            {
                loading ? (
                    <l-ring
                        size="30"
                        stroke="3"
                        bg-opacity="0"
                        speed="2"
                        color="black"
                    />
                ):(
                    <>
                        <Row className="mb-3">
                            <Col className="text-center">
                                <h4>Welcome {user.name}</h4>
                            </Col>
                        </Row>
                        <Row className="w-100 mb-4 d-flex justify-content-center statistic-row">
                            <Col xs={12} md={6} lg={4} className="d-flex justify-content-center mb-3">
                                <Card className="statistics-card">
                                    <Card.Body className="text-center">
                                        <FaUsers size={50} className="mb-2" />
                                        <Card.Title>Total d'utilisateurs</Card.Title>
                                        <Card.Text className=" fs-1">{usersCount}</Card.Text>
                                    </Card.Body> 
                                </Card>
                            </Col>
                            <Col xs={12} md={6} lg={4} className="d-flex justify-content-center mb-3">
                                <Card className="statistics-card">
                                    <Card.Body className="text-center">
                                        <FaDatabase size={50} className="mb-2" />
                                        <Card.Title>Base de données actuel</Card.Title>
                                        <Card.Text className=" fs-1">{database.db_database || "none"}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row className="w-100 mb-4 d-flex justify-content-center statistic-row">
                            <Col xs={12} md={6} lg={4} className="d-flex justify-content-center mb-3">
                                <Card className="statistics-card">
                                    <Card.Body className="text-center">
                                        <MdOutlineGeneratingTokens size={60} className="mb-2" />
                                        <Card.Title>Total input tokens</Card.Title>
                                        <Card.Text className="fs-1">{totalInputToken}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={12} md={6} lg={4} className="d-flex justify-content-center mb-3">
                                <Card className="statistics-card">
                                    <Card.Body className="text-center">
                                        <MdOutlineGeneratingTokens size={60} className="mb-2" />
                                        <Card.Title>Total output tokens</Card.Title>
                                        <Card.Text className="fs-1">{totalOutToken}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={12} md={6} lg={4} className="d-flex justify-content-center mb-3">
                                <Card className="statistics-card">
                                    <Card.Body className="text-center">
                                        <MdOutlineGeneratingTokens size={60} className="mb-2" />
                                        <Card.Title>Total tokens</Card.Title>
                                        <Card.Text className="fs-1">{totalOutToken + totalInputToken}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row className="w-100 justify-content-center">
                            <Col xs={12} className="d-flex justify-content-center">
                                <div className="dashboardChart">
                                    <Bar data={chartData} options={options} />
                                </div>
                            </Col>
                        </Row>
                    </>
                )
            }
        </Container>
    );
}

export default Dashboard;
